(() => {
  if (window.swinger.config.environment !== 'prod') {
    return;
  }

  if (!window.navigator.serviceWorker) {
    console.log('Service Worker is not supported on this platform');
    return;
  }

  const sw = window.navigator.serviceWorker;

  sw.register(`${window.swinger.config.rootBase}/sw.js?version=${window.swinger.config.version}`, {
    scope: `${window.swinger.config.rootBase}/`,
  }).then((registration) => {
    // registration worked
    console.log(`Service Worker registration succeeded. Scope is ${registration.scope}`);
  }).catch((error) => {
    // registration failed
    console.log(`Service Worker registration failed with ${error}`);
  });
})();
